export const clinicSignupConstants = {
  CLINIC_SIGNUP_PROCESSING: "CLINIC_SIGNUP_PROCESSING",
  CLINIC_SIGNUP_SUCCESS: "CLINIC_SIGNUP_SUCCESS",
  CLINIC_SIGNUP_FAILURE: "CLINIC_SIGNUP_FAILURE",

  CHECK_USER_EXISTENCE_PROCESSING: "CHECK_USER_EXISTENCE_PROCESSING",
  CHECK_USER_EXISTENCE_SUCCESS: "CHECK_USER_EXISTENCE_SUCCESS",
  CHECK_USER_EXISTENCE_FAILURE: "CHECK_USER_EXISTENCE_FAILURE"
};
